import axios from 'axios'

export const state = {
  cached: '',
}

export const getters = {}

export const mutations = {
  CACHE_ADDRESS(state, address) {
    state.cached = address
  },
}

export const actions = {
  fetchHistory({ commit, state, rootState }) {
    const cacheAddress = localStorage.getItem('CACHE_ADDRESS')
    // console.log(cacheAddress)
    if (cacheAddress && cacheAddress.length > 0) {
      return axios
        .get(`/api/faucet/by-address?address=${cacheAddress}`)
        .then((response) => {
          if (response.data != null && response.data.object != null) {
            return response.data.object
          }
          return null
        })
    }

    return Promise.resolve(null)
  },

  async requestFaucet({ commit, state, rootState }, { address }) {
    // console.log(`Address to send : ${address}`)

    return axios
      .post(`/api/faucet/request`, { address })
      .then((response) => {
        // console.log(response.data)
        commit('CACHE_ADDRESS', address)
        localStorage.setItem('CACHE_ADDRESS', address)
        return response.data
      })
      .catch(function (error) {
        // console.log(error.response.data);
        return error.response.data
      })
  },
}
